import React, { useState } from "react";
import { Box, ClickAwayListener, Tooltip } from "@mui/material";

/* Bouton d'aide rond « ? » : une ou deux phrases au survol et au clic.
   Les textes sont tous dans src/aide/textesAide.ts.
   Le clic garde la bulle ouverte (utile au clavier et sur écran tactile). */
export default function BoutonAide({ texte, libelle = "Aide" }: { texte: string; libelle?: string }) {
  const [survol, setSurvol] = useState(false);
  const [epingle, setEpingle] = useState(false);
  return (
    <ClickAwayListener onClickAway={() => setEpingle(false)}>
      <Tooltip
        title={texte}
        arrow
        placement="bottom-start"
        open={survol || epingle}
        onOpen={() => setSurvol(true)}
        onClose={() => setSurvol(false)}
        disableFocusListener={false}
      >
        <Box
          component="button"
          type="button"
          aria-label={`${libelle} : ${texte}`}
          aria-expanded={epingle}
          onClick={() => setEpingle(e => !e)}
          sx={{
            width: 22, height: 22, borderRadius: "50%", flexShrink: 0,
            border: "1.5px solid var(--c-text-primary)", background: "transparent",
            color: "var(--c-text-primary)", fontFamily: "var(--font-display)",
            fontWeight: 700, fontSize: 12, lineHeight: 1, cursor: "pointer",
            display: "inline-flex", alignItems: "center", justifyContent: "center", p: 0,
            "&:hover, &:focus-visible": { background: "var(--c-text-primary)", color: "var(--c-surface)", outline: "none" },
          }}
        >
          ?
        </Box>
      </Tooltip>
    </ClickAwayListener>
  );
}
